import { eTextures, Game } from "../../Game";
import { TIMER } from "../Gameplay";
import { Grandstand } from "./Grandstand";



export class GrandstandCrowd {
    private static readonly FRAME_CNT = 8;
    private static readonly FRAME_CHANGE_INTERVAL = 1000 / 10;

    private _crowdMaterial: pc.StandardMaterial;

    private _nextFrameTime: number;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(grandstandEnt: pc.Entity) {
        let mat = this._crowdMaterial = new pc.StandardMaterial();

        mat.diffuseMap = Game.app.assets.find(eTextures.crowdFrames, pc.eAssetType.texture).resource as pc.Texture;
        mat.chunks.endPS = Grandstand.FSHADER_END_CHUNK;
        this.setMaterialFrame(0);

        grandstandEnt.model.meshInstances[2].material = mat;

        // Cas pristiho snimku
        this._nextFrameTime = GrandstandCrowd.FRAME_CHANGE_INTERVAL;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): void {
        if (TIMER.time >= this._nextFrameTime) {
            let time = TIMER.time;

            this._nextFrameTime = time + GrandstandCrowd.FRAME_CHANGE_INTERVAL;

            let frameId = Math.floor(time / GrandstandCrowd.FRAME_CHANGE_INTERVAL) % (GrandstandCrowd.FRAME_CNT * 2);

            if (frameId >= GrandstandCrowd.FRAME_CNT)
                frameId = GrandstandCrowd.FRAME_CNT - (frameId - GrandstandCrowd.FRAME_CNT + 1);

            this.setMaterialFrame(frameId);
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private setMaterialFrame(frameId: number): void {
        let mat = this._crowdMaterial;

        const frameH = 234;
        const texH = 2048;

        mat.diffuseMapOffset.set(0, (1 - (frameH + 2) / texH) - frameId * ((frameH + 4) / texH));
        mat.diffuseMapTiling.set(1, frameH / texH);
        mat.update();
    }
}